import { ActionCreator } from 'redux';

import { FileInfo } from '@dev/ee-api/ee-api-models';

import {
    UploadFilesAction,
    UploadFilesErrorAction,
    UploadFilesStartAction,
    UploadFilesSuccessAction,
    UploadFilesUpdateProgressAction,
    DeleteUploadedFileAction,
    UploadFilesActionMedia,
    UploadActionTypes,
    UploadState,
    SetAnalyticsOpenAction,
} from './types';
import { ApplicationState } from '..';

export const UploadFiles: ActionCreator<UploadFilesAction> = (
    file: File,
    expiresAfterDays?: number
): UploadFilesAction => ({
    type: UploadActionTypes.UPLOAD_FILES,
    payload: {
        file,
        expiresAfterDays,
    },
});

export const UploadFilesMedia: ActionCreator<UploadFilesActionMedia> = (
    file: File,
    expiresAfterDays?: number
): UploadFilesActionMedia => ({
    type: UploadActionTypes.UPLOAD_MEDIA_FILES,
    payload: {
        file,
        expiresAfterDays,
    },
});

export const UpdateProgress: ActionCreator<UploadFilesUpdateProgressAction> = (
    progress: number
): UploadFilesUpdateProgressAction => ({
    type: UploadActionTypes.UPLOAD_FILE_PROGRESS_UPDATE,
    payload: {
        progress,
    },
});

export const StartUpload: ActionCreator<UploadFilesStartAction> = (): UploadFilesStartAction => ({
    type: UploadActionTypes.UPLOAD_FILES_START,
});

export const UploadError: ActionCreator<UploadFilesErrorAction> = (): UploadFilesErrorAction => ({
    type: UploadActionTypes.UPLOAD_ERROR,
});

export const UploadSuccess: ActionCreator<UploadFilesSuccessAction> = (
    fileuploaded: FileInfo
): UploadFilesSuccessAction => ({
    type: UploadActionTypes.UPLOAD_SUCCESS,
    payload: {
        fileuploaded,
    },
});

export const DeleteUploadedFile: ActionCreator<DeleteUploadedFileAction> = (): DeleteUploadedFileAction => ({
    type: UploadActionTypes.DELETE_FILE,
    payload: {
        fileuploaded: null,
    },
});

export const SetAnalyticsOpen = (isAnalyticsOpen: boolean): SetAnalyticsOpenAction => ({
    type: UploadActionTypes.SET_ANALYTICS_OPEN,
    payload: { isAnalyticsOpen },
});

export const getUploadStore = (state: ApplicationState): UploadState => state.upload;
